// Google Map
import { AgmCoreModule } from '@agm/core';
import * as ngCommon from '@angular/common';
import { DecimalPipe } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatNativeDateModule } from '@angular/material';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
// Material Modules
import { MatMenuModule } from '@angular/material/menu';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
// Kendo Modules
import { HttpClientModule } from '@angular/common/http';
import { ExcelModule, GridModule, PDFModule } from '@progress/kendo-angular-grid';
import { SchedulerModule } from '@progress/kendo-angular-scheduler';
import { TooltipModule } from '@progress/kendo-angular-tooltip';
import { TreeViewModule } from '@progress/kendo-angular-treeview';
import { UploadsModule } from '@progress/kendo-angular-upload';
import { ChartsModule } from "@progress/kendo-angular-charts";
import 'hammerjs';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
import { PopoverModule } from 'ngx-smart-popover';
import { ToastrModule } from 'ngx-toastr';
import { CommonService } from 'src/app-core/services/common.service';
import { UtilsModule } from 'src/app-core/utils.module';
import { ContactService } from '../contacts/contact.service';
import { CustomerService } from '../customer/customer.service';
import { PopupFormComponent } from '../popup/popup-form/popup-form.component';
import { PopupService } from '../popup/popup.service';
import { AccountBoxMappingListComponent } from './account-box-mapping-list/account-box-mapping-list.component';
import { AccountOrderParticipantsConfiguationComponent } from './account-order-participants-configuation/account-order-participants-configuation.component';
import { AccountTaxConfigurationComponent } from './account-tax-configuration/account-tax-configuration.component';
import { AddAddressComponent } from './add-address/add-address.component';
import { AddContactComponent } from './add-contact/add-contact.component';
import { ContactFormDialogComponent } from './add-contact/contact-form-dialog/contact-form-dialog.component';
import { AddressFieldComponent } from './address-fields/address-fields.component';
import { AddressListComponent } from './address-list/address-list.component';
import { AppoinmentListComponent } from './appoinment-list/appoinment-list.component';
import { AppointmentDetailsPopupComponent } from './appointment-details-popup/appointment-details-popup.component';
import { AppointmentFormComponent } from './appointment-form/appointment-form.component';
import { AppointmentsTasksCalendarComponent } from './appointments-tasks-calendar/appointments-tasks-calendar.component';
import { AppointmentsTasksListComponent } from './appointments-tasks-list/appointments-tasks-list.component';
import { BolEditFormComponent } from './bol-edit-form/bol-edit-form.component';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { ContactDetailsPopupComponent } from './contact-details-popup/contact-details-popup.component';
import { ContactListComponent } from './contact-list/contact-list.component';
import { ContainerCushioningListComponent } from './container-cushioning-list/container-cushioning-list.component';
import { ContainerModifiersLaborBreakUpComponent } from './container-modifiers-labor-break-up/container-modifiers-labor-break-up.component';
import { ContainerNoncushioningListComponent } from './container-noncushioning-list/container-noncushioning-list.component';
import { ContainerSummaryComponent } from './container-summary/container-summary.component';
import { CushioningDetailsFormComponent } from './cushioning-details-form/cushioning-details-form.component';
import { CustomerDetailsPopupComponent } from './customer-details-popup/customer-details-popup.component';
import { CustomerEditFormPopupComponent } from './customer-edit-form-popup/customer-edit-form-popup.component';
import { CustomerJobListComponent } from './customer-job-list/customer-job-list.component';
import { DateRangeFormComponent } from './date-range-form/date-range-form.component';
import { DocumentListComponent } from './document-list/document-list.component';
import { DocumentsUploadFormComponent } from './documents-upload-form/documents-upload-form.component';
import { EmailGenerationFormComponent } from './email-generation-form/email-generation-form.component';
import { FreightShopperCarrierListComponent } from './freight-shopper-carrier-list/freight-shopper-carrier-list.component';
import { HouseBillCustomEditFormComponent } from './house-bill-custom-edit-form/house-bill-custom-edit-form.component';
import { HouseBillEditFormComponent } from './house-bill-edit-form/house-bill-edit-form.component';
import { InsuranceCostBreakdownComponent } from './insurance-cost-breakdown/insurance-cost-breakdown.component';
import { AccountDialogComponent } from './lead-account-add-form/account-dialog/account-dialog.component';
import { LeadAccountAddFormComponent } from './lead-account-add-form/lead-account-add-form.component';
import { LeadAccountDetailsPopupComponent } from './lead-account-details-popup/lead-account-details-popup.component';
import { LeadEditFormPopupComponent } from './lead-edit-form-popup/lead-edit-form-popup.component';
import { LeadJobListComponent } from './lead-job-list/lead-job-list.component';
import { LocationFormComponent } from './location-form/location-form.component';
import { MarkupsListComponent } from './markups-list/markups-list.component';
import { ModifiersStructuresComponent } from './modifiers-structures/modifiers-structures.component';
import { NotesFormComponent } from './notes-list/notes-form/notes-form.component';
import { OrderPreviewDialogComponent } from './order-preview-dialog/order-preview-dialog.component';
import { OrderTrackingComponent } from './order-tracking/order-tracking.component';
import { OrdersCustomAddressComponent } from './orders-custom-address/orders-custom-address.component';
import { OrdersDeliveryDetailsComponent } from './orders-delivery-details/orders-delivery-details.component';
import { AccountDocumentDialogComponent } from './orders-documents-list/account-document-dialog/account-document-dialog.component';
import { OrdersDocumentsListComponent } from './orders-documents-list/orders-documents-list.component';
import { OrdersEstimateBreakdownListComponent } from './orders-estimate-breakdown-list/orders-estimate-breakdown-list.component';
import { OrdersFinalDimsRoutingComponent } from './orders-final-dims-routing/orders-final-dims-routing.component';
import { OrdersFloaterSpacingComponent } from './orders-floater-spacing/orders-floater-spacing.component';
import { OrdersFreightShopperFormComponent } from './orders-freight-shopper-form/orders-freight-shopper-form.component';
import { OrdersFreightShopperListComponent } from './orders-freight-shopper-list/orders-freight-shopper-list.component';
import { OrdersInsuranceComponent } from './orders-insurance/orders-insurance.component';
import { OrdersItemSpacingComponent } from './orders-item-spacing/orders-item-spacing.component';
import { OrdersMaterialGridComponent } from './orders-material-grid/orders-material-grid.component';
import { OrdersModifiersStructuresComponent } from './orders-modifiers-structures/orders-modifiers-structures.component';
import { OrdersNotesFormComponent } from './orders-notes-form/orders-notes-form.component';
import { OrdersNotesListComponent } from './orders-notes-list/orders-notes-list.component';
import { OrdersRfqDetailsComponent } from './orders-rfq-details/orders-rfq-details.component';
import { OrdersServicesListComponent } from './orders-services-list/orders-services-list.component';
import { OrdersShippingFormComponent } from './orders-shipping-form/orders-shipping-form.component';
import { OrdersShippingUnitListComponent } from './orders-shipping-unit-list/orders-shipping-unit-list.component';
import { OrdersStatusChangeFormComponent } from './orders-status-change-form/orders-status-change-form.component';
import { OrdersTypeDocumentsComponent } from './orders-type-documents/orders-type-documents.component';
import { OrdersUploadedDocumentsComponent } from './orders-uploaded-documents/orders-uploaded-documents.component';
import { OrdersViewNotesFormComponent } from './orders-view-notes-form/orders-view-notes-form.component';
import { PhoneNumberFormComponent } from './phone-number-form/phone-number-form.component';
import { PopupDialogComponent } from './popup-dialog/popup-dialog.component';
import { PopupListComponent } from './popup-list/popup-list.component';
import { AddQuickContactComponentForm } from './quick-contact/add-quick-contact-form.component';
import { ServicesListComponent } from './services-list/services-list.component';
import { StatusCarrierBuildIntransitComponent } from './status-carrier-build-intransit/status-carrier-build-intransit.component';
import { TodaysAppointmentPrintComponent } from './todays-appointment-print/todays-appointment-print.component';
import { MapDialogComponent } from './orders-shipping-form/map-dialog/map-dialog.component';
import { NotesListComponent } from './notes-list/notes-list.component';
import { OrdersCarrierCostsListComponent } from './orders-carrier-costs-list/orders-carrier-costs-list.component';
import { OrderEmailPopupFormComponent } from './order-email-popup-form/order-email-popup-form.component';
import { OrderExcessValueFormComponent } from './order-excess-value-form/order-excess-value-form.component';
import { OrdersAccountFormComponent } from './orders-account-form/orders-account-form.component';
import { OrdersActionCommonFormComponent } from './orders-action-common-form/orders-action-common-form.component';
import { OrdersActivityListComponent } from './orders-activity-list/orders-activity-list.component';
import { OrdersAdminRequestsComponent } from './orders-admin-requests/orders-admin-requests.component';
import { OrdersAppointmentsTasksComponent } from './orders-appointments-tasks/orders-appointments-tasks.component';
import { OrdersAssignedtoFormComponent } from './orders-assignedto-form/orders-assignedto-form.component';
import { OrdersBreadcrumbsComponent } from './orders-breadcrumbs/orders-breadcrumbs.component';
import { OrdersBulkStatusChangeFormComponent } from './orders-bulk-status-change-form/orders-bulk-status-change-form.component';
import { OrdersConatinerFutureUseFormComponent } from './orders-conatiner-future-use-form/orders-conatiner-future-use-form.component';
import { OrdersContainerItemListComponent } from './orders-container-item-list/orders-container-item-list.component';
import { OrdersContainerItemMoveFormComponent } from './orders-container-item-move-form/orders-container-item-move-form.component';
import { OrdersContainerListComponent } from './orders-container-list/orders-container-list.component';
import { OrdersContainerPackagingComponent } from './orders-container-packaging/orders-container-packaging.component';
import { OrdersCopyContainerItemFormComponent } from './orders-copy-container-item-form/orders-copy-container-item-form.component';
import { RouterModule } from '@angular/router';
import { PopupDialogWithDropdownComponent } from './popup-dialog-with-dropdown/popup-dialog-with-dropdown.component';
import { PdfDialogComponent } from './pdf-dialog/pdf-dialog.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { NgxMaskModule } from 'ngx-mask';
import { SessionLogoutPopupComponent } from './session-logout-popup/session-logout-popup.component';
import { AddNationalZipcodeDialogComponent } from './add-national-zipcode-dialog/add-national-zipcode-dialog.component';
import { NoteFormComponent } from './note-form/note-form.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { RetainModifiersDialogComponent } from './retain-modifiers-dialog/retain-modifiers-dialog.component';
import { CloneConfirmationPopupComponent } from './clone-confirmation-popup/clone-confirmation-popup.component';
import { FullAccountConfirmationComponent } from './full-account-confirmation/full-account-confirmation.component';

@NgModule({
    imports: [
        RouterModule,
        ngCommon.CommonModule,
        FormsModule,
        ReactiveFormsModule,
        AgmCoreModule.forRoot({
            apiKey: 'AIzaSyDUkvD6SoraIscll-06YIkHTlysR7P--6w',
            libraries: ['places', 'drawing', 'geometry'],
        }),
        GridModule,
        PDFModule,
        SchedulerModule,
        TreeViewModule,
        HttpClientModule,
        UploadsModule,
        ChartsModule,
        ExcelModule,
        TooltipModule,
        DateInputsModule,
        DropDownsModule,
        MatMenuModule,
        MatInputModule,
        MatButtonModule,
        MatButtonToggleModule,
        MatCheckboxModule,
        MatRadioModule,
        MatDialogModule,
        MatExpansionModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatBadgeModule,
        MatSlideToggleModule,
        MatTooltipModule,
        MatTabsModule,
        MatSelectModule,
        MatAutocompleteModule,
        MatListModule,
        MatIconModule,
        MatChipsModule,
        MatSidenavModule,
        MatCardModule,
        ToastrModule.forRoot({
            closeButton: true,
            progressBar: true,
            progressAnimation: 'increasing',
            positionClass: 'toast-top-right',
            timeOut: 2000,
        }),
        PopoverModule,
        DropDownsModule,
        UtilsModule,
        OwlDateTimeModule,
        OwlNativeDateTimeModule,
        PdfViewerModule,
        NgxMaskModule.forRoot({
            showMaskTyped: true
        })
    ],
    declarations: [
        ContactFormDialogComponent,
        AddContactComponent,
        AppoinmentListComponent,
        NotesListComponent,
        PopupListComponent,
        DocumentListComponent,
        ServicesListComponent,
        ContactListComponent,
        AddressListComponent,
        AddAddressComponent,
        PhoneNumberFormComponent,
        LocationFormComponent,
        NotesFormComponent,
        LeadAccountAddFormComponent,
        ConfirmDialogComponent,
        PopupDialogComponent,
        AddressFieldComponent,
        OrdersCustomAddressComponent,
        OrdersShippingFormComponent,
        OrdersFreightShopperFormComponent,
        OrdersFreightShopperListComponent,
        OrdersCarrierCostsListComponent,
        OrdersInsuranceComponent,
        OrdersNotesFormComponent,
        OrdersServicesListComponent,
        OrdersContainerItemListComponent,
        OrdersContainerListComponent,
        OrdersBreadcrumbsComponent,
        ModifiersStructuresComponent,
        OrdersModifiersStructuresComponent,
        OrdersMaterialGridComponent,
        OrdersFloaterSpacingComponent,
        OrdersItemSpacingComponent,
        OrdersContainerPackagingComponent,
        ContainerNoncushioningListComponent,
        ContainerCushioningListComponent,
        CushioningDetailsFormComponent,
        ContainerSummaryComponent,
        CustomerDetailsPopupComponent,
        CustomerJobListComponent,
        ContactDetailsPopupComponent,
        LeadAccountDetailsPopupComponent,
        LeadJobListComponent,
        OrdersAccountFormComponent,
        OrdersEstimateBreakdownListComponent,
        OrdersAppointmentsTasksComponent,
        AppointmentsTasksCalendarComponent,
        AppointmentsTasksListComponent,
        ContainerModifiersLaborBreakUpComponent,
        OrdersDocumentsListComponent,
        OrdersTypeDocumentsComponent,
        OrdersAdminRequestsComponent,
        OrdersUploadedDocumentsComponent,
        OrdersContainerItemMoveFormComponent,
        EmailGenerationFormComponent,
        HouseBillEditFormComponent,
        HouseBillCustomEditFormComponent,
        BolEditFormComponent,
        InsuranceCostBreakdownComponent,
        OrdersNotesListComponent,
        OrdersConatinerFutureUseFormComponent,
        OrdersCopyContainerItemFormComponent,
        AppointmentFormComponent,
        OrdersStatusChangeFormComponent,
        OrderEmailPopupFormComponent,
        MarkupsListComponent,
        OrderExcessValueFormComponent,
        OrdersRfqDetailsComponent,
        OrdersFinalDimsRoutingComponent,
        PopupFormComponent,
        DocumentsUploadFormComponent,
        OrdersBulkStatusChangeFormComponent,
        AddQuickContactComponentForm,
        OrdersAssignedtoFormComponent,
        OrdersDeliveryDetailsComponent,
        OrdersActionCommonFormComponent,
        OrdersShippingUnitListComponent,
        OrdersViewNotesFormComponent,
        OrdersActivityListComponent,
        FreightShopperCarrierListComponent,
        AccountBoxMappingListComponent,
        AccountTaxConfigurationComponent,
        TodaysAppointmentPrintComponent,
        StatusCarrierBuildIntransitComponent,
        CustomerEditFormPopupComponent,
        LeadEditFormPopupComponent,
        DateRangeFormComponent,
        AppointmentDetailsPopupComponent,
        AccountOrderParticipantsConfiguationComponent,
        AccountDialogComponent,
        AccountDocumentDialogComponent,
        MapDialogComponent,
        OrderPreviewDialogComponent,
        OrderTrackingComponent,
        AccountDocumentDialogComponent,
        PopupDialogWithDropdownComponent,
        PdfDialogComponent,
        SessionLogoutPopupComponent,
        AddNationalZipcodeDialogComponent,
        PageNotFoundComponent,
        NoteFormComponent,
        RetainModifiersDialogComponent,
        CloneConfirmationPopupComponent,
        FullAccountConfirmationComponent
    ],
    exports: [
        GridModule,
        PDFModule,
        SchedulerModule,
        TreeViewModule,
        HttpClientModule,
        UploadsModule,
        ChartsModule,
        ExcelModule,
        TooltipModule,
        DateInputsModule,
        DropDownsModule,
        MatMenuModule,
        MatInputModule,
        MatButtonModule,
        MatButtonToggleModule,
        MatCheckboxModule,
        MatRadioModule,
        MatDialogModule,
        MatExpansionModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatBadgeModule,
        MatSlideToggleModule,
        MatTooltipModule,
        MatTabsModule,
        MatSelectModule,
        MatAutocompleteModule,
        MatListModule,
        MatIconModule,
        MatChipsModule,
        MatSidenavModule,
        MatCardModule,
        PopoverModule,
        ContactFormDialogComponent,
        AddContactComponent,
        AppoinmentListComponent,
        NotesListComponent,
        PopupListComponent,
        DocumentListComponent,
        ServicesListComponent,
        ContactListComponent,
        AddressListComponent,
        AddAddressComponent,
        PhoneNumberFormComponent,
        LocationFormComponent,
        DropDownsModule,
        UtilsModule,
        NotesFormComponent,
        LeadAccountAddFormComponent,
        ConfirmDialogComponent,
        PopupDialogComponent,
        AddressFieldComponent,
        OrdersCustomAddressComponent,
        OrdersShippingFormComponent,
        OrdersFreightShopperFormComponent,
        OrdersFreightShopperListComponent,
        OrdersCarrierCostsListComponent,
        OrdersInsuranceComponent,
        OrdersNotesFormComponent,
        OrdersServicesListComponent,
        OrdersContainerItemListComponent,
        OrdersContainerListComponent,
        OrdersBreadcrumbsComponent,
        ModifiersStructuresComponent,
        OrdersModifiersStructuresComponent,
        OrdersMaterialGridComponent,
        OrdersContainerPackagingComponent,
        ContainerNoncushioningListComponent,
        ContainerCushioningListComponent,
        CushioningDetailsFormComponent,
        ContainerSummaryComponent,
        CustomerDetailsPopupComponent,
        CustomerJobListComponent,
        ContactDetailsPopupComponent,
        LeadAccountDetailsPopupComponent,
        LeadJobListComponent,
        OrdersAccountFormComponent,
        OrdersEstimateBreakdownListComponent,
        OrdersAppointmentsTasksComponent,
        AppointmentsTasksCalendarComponent,
        AppointmentsTasksListComponent,
        ContainerModifiersLaborBreakUpComponent,
        OrdersDocumentsListComponent,
        OrdersTypeDocumentsComponent,
        OrdersAdminRequestsComponent,
        OrdersUploadedDocumentsComponent,
        OrdersContainerItemMoveFormComponent,
        EmailGenerationFormComponent,
        HouseBillEditFormComponent,
        HouseBillCustomEditFormComponent,
        BolEditFormComponent,
        InsuranceCostBreakdownComponent,
        OrdersItemSpacingComponent,
        OrdersNotesListComponent,
        OrdersConatinerFutureUseFormComponent,
        OrdersCopyContainerItemFormComponent,
        AppointmentFormComponent,
        OrdersStatusChangeFormComponent,
        OrderEmailPopupFormComponent,
        MarkupsListComponent,
        OrderExcessValueFormComponent,
        OrdersRfqDetailsComponent,
        OrdersFinalDimsRoutingComponent,
        PopupFormComponent,
        DocumentsUploadFormComponent,
        OwlDateTimeModule,
        OwlNativeDateTimeModule,
        OrdersBulkStatusChangeFormComponent,
        AddQuickContactComponentForm,
        OrdersAssignedtoFormComponent,
        OrdersDeliveryDetailsComponent,
        OrdersActionCommonFormComponent,
        OrdersShippingUnitListComponent,
        OrdersViewNotesFormComponent,
        OrdersActivityListComponent,
        AccountBoxMappingListComponent,
        AccountTaxConfigurationComponent,
        StatusCarrierBuildIntransitComponent,
        CustomerEditFormPopupComponent,
        LeadEditFormPopupComponent,
        DateRangeFormComponent,
        AppointmentDetailsPopupComponent,
        AccountOrderParticipantsConfiguationComponent,
        OrderPreviewDialogComponent,
        OrderTrackingComponent,
        PopupDialogWithDropdownComponent,
        PdfViewerModule,
        NgxMaskModule,
        AddNationalZipcodeDialogComponent,
        NoteFormComponent,
        PageNotFoundComponent,
        RetainModifiersDialogComponent
    ],
    entryComponents: [
        PageNotFoundComponent,
        ContactFormDialogComponent,
        AddAddressComponent,
        NotesFormComponent,
        LeadAccountAddFormComponent,
        ConfirmDialogComponent,
        PopupDialogComponent,
        OrdersCustomAddressComponent,
        OrdersShippingFormComponent,
        OrdersFreightShopperFormComponent,
        OrdersFreightShopperListComponent,
        OrdersCarrierCostsListComponent,
        OrdersInsuranceComponent,
        OrdersNotesFormComponent,
        OrdersServicesListComponent,
        OrdersContainerItemListComponent,
        OrdersContainerListComponent,
        OrdersBreadcrumbsComponent,
        ModifiersStructuresComponent,
        OrdersModifiersStructuresComponent,
        OrdersMaterialGridComponent,
        OrdersContainerPackagingComponent,
        ContainerNoncushioningListComponent,
        ContainerCushioningListComponent,
        CushioningDetailsFormComponent,
        ContainerSummaryComponent,
        CustomerDetailsPopupComponent,
        CustomerJobListComponent,
        ContactDetailsPopupComponent,
        LeadAccountDetailsPopupComponent,
        LeadJobListComponent,
        OrdersAccountFormComponent,
        OrdersEstimateBreakdownListComponent,
        OrdersAppointmentsTasksComponent,
        AppointmentsTasksCalendarComponent,
        AppointmentsTasksListComponent,
        ContainerModifiersLaborBreakUpComponent,
        OrdersDocumentsListComponent,
        OrdersTypeDocumentsComponent,
        OrdersAdminRequestsComponent,
        OrdersUploadedDocumentsComponent,
        OrdersContainerItemMoveFormComponent,
        EmailGenerationFormComponent,
        HouseBillEditFormComponent,
        HouseBillCustomEditFormComponent,
        BolEditFormComponent,
        InsuranceCostBreakdownComponent,
        OrdersItemSpacingComponent,
        OrdersNotesListComponent,
        OrdersConatinerFutureUseFormComponent,
        OrdersCopyContainerItemFormComponent,
        AppointmentFormComponent,
        OrdersStatusChangeFormComponent,
        OrderEmailPopupFormComponent,
        MarkupsListComponent,
        OrderExcessValueFormComponent,
        OrdersRfqDetailsComponent,
        OrdersFinalDimsRoutingComponent,
        PopupFormComponent,
        DocumentsUploadFormComponent,
        OrdersBulkStatusChangeFormComponent,
        AddQuickContactComponentForm,
        OrdersAssignedtoFormComponent,
        OrdersDeliveryDetailsComponent,
        OrdersActionCommonFormComponent,
        OrdersShippingUnitListComponent,
        OrdersViewNotesFormComponent,
        OrdersActivityListComponent,
        AccountBoxMappingListComponent,
        AccountTaxConfigurationComponent,
        StatusCarrierBuildIntransitComponent,
        CustomerEditFormPopupComponent,
        LeadEditFormPopupComponent,
        AppointmentDetailsPopupComponent,
        AccountOrderParticipantsConfiguationComponent,
        AccountDialogComponent,
        AccountDocumentDialogComponent,
        MapDialogComponent,
        OrderPreviewDialogComponent,
        OrderTrackingComponent,
        AccountDocumentDialogComponent,
        PopupDialogWithDropdownComponent,
        PdfDialogComponent,
        SessionLogoutPopupComponent,
        AddNationalZipcodeDialogComponent,
        RetainModifiersDialogComponent,
        CloneConfirmationPopupComponent,
        FullAccountConfirmationComponent
    ],
    providers: [
        CustomerService,
        CommonService,
        PopupService,
        ContactService,
        DecimalPipe
    ],
})
export class AppCommonModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: AppCommonModule,
            providers: [],
        };
    }
}
